import { useQueryClient } from 'react-query';
import { IPaginationParams } from '../../../../types';
import { ISchoolMonitoringEventSimpleProps, ISchoolMonitoringFilterProps } from '../../types';
import { SCHOOL_MONITORING_KEYS } from '../useQuery';

export const useSchoolMonitoringEventDataStreamCache = () => {
  const queryClient = useQueryClient();

  return {
    setCacheData: (
      data: ISchoolMonitoringEventSimpleProps[],
      pagination: IPaginationParams,
      filter?: ISchoolMonitoringFilterProps
    ) =>
      queryClient.setQueryData(
        [SCHOOL_MONITORING_KEYS.ALL, SCHOOL_MONITORING_KEYS.LIST, pagination, filter],
        data,
      ),
      
    clearCacheData: () => {
      queryClient.invalidateQueries([SCHOOL_MONITORING_KEYS.ALL]);
    },
  };
};
